
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24","rx":"12"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.931 6.374A.679.679 0 0018.323 6H5.677a.678.678 0 00-.608.374.658.658 0 00.074.702l5.733 7.254v5.221c0 .248.204.449.456.449h1.336a.453.453 0 00.456-.449v-5.22l5.733-7.255a.658.658 0 00.074-.702zm-2.317 1.37l-4.41 5.579a.26.26 0 01-.408 0l-4.41-5.58a.254.254 0 01.204-.41h8.82c.215 0 .335.243.204.41z","fill":"#fff"}})])
          )
        }
      }
    